/**
 * IntroSlider
 *
 * Shows an intro/sponsor image at the beginning of
 * the slideshow. It scales to fit the screen.
 */
import React from "react";

export default function IntroSlider({ image }) {
  if (!image) return null;
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "transparent",
      }}
    >
      <img
        src={image.url}
        alt={image.fileName || "Intro image .. Something went wrong"}
        style={{
          maxWidth: "100%",
          maxHeight: "100%",
          objectFit: "contain",
        }}
      />
    </div>
  );
}
